import LoadingModal from '@components/atoms/modals/LoadingModal';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router';

const PrivacyPolicyPage = lazy(() => import('@pages/help/PrivacyPolicyPage'));
const CookiePolicyPage = lazy(() => import('@pages/help/CookiePolicyPage'));
const TermsAndConditionsPage = lazy(
    () => import('@pages/help/TermsAndConditionsPage')
);
const EndUserAgreementPage = lazy(
    () => import('@pages/help/EndUserAgreementPage')
);
const DisclaimerPage = lazy(() => import('@pages/help/DisclaimerPage'));

export const LegalRoutes = (
    <>
        <Route
            key="/legal/privacy-policy"
            path="/legal/privacy-policy"
            element={
                <Suspense fallback={<LoadingModal />}>
                    <PrivacyPolicyPage />
                </Suspense>
            }
        />
        <Route
            key="/legal/cookie-policy"
            path="/legal/cookie-policy"
            element={
                <Suspense fallback={<LoadingModal />}>
                    <CookiePolicyPage />
                </Suspense>
            }
        />
        <Route
            key="/legal/terms-and-conditions"
            path="/legal/terms-and-conditions"
            element={
                <Suspense fallback={<LoadingModal />}>
                    <TermsAndConditionsPage />
                </Suspense>
            }
        />
        <Route
            key="/legal/eula"
            path="/legal/eula"
            element={
                <Suspense fallback={<LoadingModal />}>
                    <EndUserAgreementPage />
                </Suspense>
            }
        />
        <Route
            key="/legal/disclaimer"
            path="/legal/disclaimer"
            element={
                <Suspense fallback={<LoadingModal />}>
                    <DisclaimerPage />
                </Suspense>
            }
        />
    </>
);
